export { default } from "./paymentSummaryCard";
